let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9F4Mz")).then(() => parcelRequire('7uVkM'));